import React from "react";
import _Notifications from "~/components/Shared/Notifications";
import { useNotificationsStore } from "~/stores";

/**
 * Notifications
 */
const Notifications = () => {
    /**
     * Get notifications from store
     */
    const { notifications, resetNotifications: restNotifications } =
        useNotificationsStore();
    /**
     * Render
     */
    return (
        <_Notifications
            id="notification"
            notifications={notifications}
            dismiss={() => restNotifications()}
        />
    );
};
export default React.memo(Notifications);
